"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pointer = _interopRequireWildcard(require("./Pointer.js"));

var _functions = require("../functions.js");

var _condition = require("../events/condition.js");

var _easing = require("../easing.js");

var _coordinate = require("../coordinate.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/DragPan
 */


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */

/**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */
var DragPan =
/** @class */
function (_super) {
  __extends(DragPan, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function DragPan(opt_options) {
    var _this = _super.call(this, {
      stopDown: _functions.FALSE
    }) || this;

    var options = opt_options ? opt_options : {};
    /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */

    _this.kinetic_ = options.kinetic;
    /**
     * @type {import("../pixel.js").Pixel}
     */

    _this.lastCentroid = null;
    /**
     * @type {number}
     */

    _this.lastPointersCount_;
    /**
     * @type {boolean}
     */

    _this.panning_ = false;
    var condition = options.condition ? options.condition : (0, _condition.all)(_condition.noModifierKeys, _condition.primaryAction);
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.onFocusOnly ? (0, _condition.all)(_condition.focusWithTabindex, condition) : condition;
    /**
     * @private
     * @type {boolean}
     */

    _this.noKinetic_ = false;
    return _this;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  DragPan.prototype.handleDragEvent = function (mapBrowserEvent) {
    if (!this.panning_) {
      this.panning_ = true;
      this.getMap().getView().beginInteraction();
    }

    var targetPointers = this.targetPointers;
    var centroid = (0, _Pointer.centroid)(targetPointers);

    if (targetPointers.length == this.lastPointersCount_) {
      if (this.kinetic_) {
        this.kinetic_.update(centroid[0], centroid[1]);
      }

      if (this.lastCentroid) {
        var delta = [this.lastCentroid[0] - centroid[0], centroid[1] - this.lastCentroid[1]];
        var map = mapBrowserEvent.map;
        var view = map.getView();
        (0, _coordinate.scale)(delta, view.getResolution());
        (0, _coordinate.rotate)(delta, view.getRotation());
        view.adjustCenterInternal(delta);
      }
    } else if (this.kinetic_) {
      // reset so we don't overestimate the kinetic energy after
      // after one finger down, tiny drag, second finger down
      this.kinetic_.begin();
    }

    this.lastCentroid = centroid;
    this.lastPointersCount_ = targetPointers.length;
    mapBrowserEvent.originalEvent.preventDefault();
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragPan.prototype.handleUpEvent = function (mapBrowserEvent) {
    var map = mapBrowserEvent.map;
    var view = map.getView();

    if (this.targetPointers.length === 0) {
      if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
        var distance = this.kinetic_.getDistance();
        var angle = this.kinetic_.getAngle();
        var center = view.getCenterInternal();
        var centerpx = map.getPixelFromCoordinateInternal(center);
        var dest = map.getCoordinateFromPixelInternal([centerpx[0] - distance * Math.cos(angle), centerpx[1] - distance * Math.sin(angle)]);
        view.animateInternal({
          center: view.getConstrainedCenter(dest),
          duration: 500,
          easing: _easing.easeOut
        });
      }

      if (this.panning_) {
        this.panning_ = false;
        view.endInteraction();
      }

      return false;
    } else {
      if (this.kinetic_) {
        // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
      }

      this.lastCentroid = null;
      return true;
    }
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragPan.prototype.handleDownEvent = function (mapBrowserEvent) {
    if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
      var map = mapBrowserEvent.map;
      var view = map.getView();
      this.lastCentroid = null; // stop any current animation

      if (view.getAnimating()) {
        view.cancelAnimations();
      }

      if (this.kinetic_) {
        this.kinetic_.begin();
      } // No kinetic as soon as more than one pointer on the screen is
      // detected. This is to prevent nasty pans after pinch.


      this.noKinetic_ = this.targetPointers.length > 1;
      return true;
    } else {
      return false;
    }
  };

  return DragPan;
}(_Pointer["default"]);

var _default = DragPan;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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